

import { motion } from 'framer-motion';
import { Wrench, SlidersHorizontal, Puzzle, MessageSquare, BarChart3, Heart } from 'lucide-react';

export default function Features() {
  const features = [
    {
      icon: <Wrench size={24} />,
      title: "Self-Service",
      description: "Set up in 15 minutes. No implementation team required."
    },
    {
      icon: <SlidersHorizontal size={24} />,
      title: "No-Code Rules",
      description: "Define validation rules visually. Change them anytime."
    },
    {
      icon: <Puzzle size={24} />,
      title: "Multi-Tool",
      description: "Works with Jira, ServiceNow, Linear, Asana, GitHub Issues, Azure DevOps."
    },
    {
      icon: <MessageSquare size={24} />,
      title: "Clear Messages",
      description: "Not 'ERROR: Invalid.' But 'To help the team, this needs reproduction steps.'"
    },
    {
      icon: <BarChart3 size={24} />,
      title: "Real-Time Dashboard",
      description: "See what's being blocked, what's most commonly missing, trends over time."
    },
    {
      icon: <Heart size={24} />,
      title: "Team-Friendly",
      description: "Built to help, not shame. Everyone feels supported, not policed."
    }
  ];

  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-primary mb-4">
            Built for teams, not bureaucrats
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="flex gap-4 items-start p-6 rounded-xl hover:bg-gray-50 transition-colors"
            >
              <div className="flex-shrink-0 w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center text-accent">
                {feature.icon}
              </div>
              <div>
                <h3 className="text-lg font-bold text-primary mb-2">{feature.title}</h3>
                <p className="text-text-muted leading-relaxed">{feature.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
